import React from "react";
import PropTypes from "prop-types";

import { Divider, BackLink, SecondaryContentContainer } from "./styles";
import Flexbox from "core/Flexbox";
import ShareSocials from "core/ShareSocials";
import colors from "core/colors";
import AttributionAreaAnimationContainer from "icons/AttributionBacklink/AnimationContainer";

import { convertPxToRem } from "frontend/components/helpers";

import { ICON_DETAIL_PAGE } from "data/links";

const SecondaryContent = ({ icon, onBack, showBackLink = true }) => {
    return (
        <AttributionAreaAnimationContainer>
            <SecondaryContentContainer>
                <Divider />
                <Flexbox
                    alignItems="center"
                    justifyContent="space-between"
                    flexDirection={showBackLink ? "row" : "row-reverse"}
                >
                    {showBackLink && (
                        <BackLink onClick={onBack}>
                            Back to all purchase options
                        </BackLink>
                    )}
                    <ShareSocials
                        spaceBetweenIcons={convertPxToRem({ px: 16 })}
                        creatorName={icon.creator.name}
                        imageType="icon"
                        permalinkPath={ICON_DETAIL_PAGE.replace(
                            ":slugWithId",
                            icon.slugWithId
                        )}
                        socialIconHeight={28}
                        socialIconWidth={28}
                        socialIconColor={colors.primary.diamond}
                    />
                </Flexbox>
            </SecondaryContentContainer>
        </AttributionAreaAnimationContainer>
    );
};

SecondaryContent.propTypes = {
    icon: PropTypes.object.isRequired,
    onBack: PropTypes.func.isRequired,
    showBackLink: PropTypes.bool
};

export default SecondaryContent;
